import type { CliChoice } from "@/components/ui/cli-logo";

/**
 * Whose face a piece of work shows. The one rule (2026-10-31):
 *
 * - `coding-cli`: the user's coding session in their own coding app shows
 *   that app's logo (Claude Code, Codex, OpenCode).
 * - `app`: work that operates or targets apps shows the app's icon.
 * - `denker`: everything else is Denker's work — chats, helpers, sub-agents,
 *   template jobs — and shows Denker's avatar in the project's
 *   colour, whatever CLI happens to run it.
 */
export type AgentAvatarKind =
  | { kind: "coding-cli"; cli: CliChoice }
  | { kind: "app" }
  | { kind: "denker" };

export interface AgentAvatarSubject {
  /** The coding app of the user's coding session; null for Denker's runs. */
  codingProvider?: CliChoice | null;
  /** The work operates or targets at least one known app. */
  hasApps: boolean;
}

export function agentAvatarKind({
  codingProvider,
  hasApps,
}: AgentAvatarSubject): AgentAvatarKind {
  if (codingProvider) return { kind: "coding-cli", cli: codingProvider };
  if (hasApps) return { kind: "app" };
  return { kind: "denker" };
}
